module.exports = __webpack_public_path__ + "static/media/Solgaleo_gaussian2.93aa5aee.png";